/**
 * Author: Paul Grejaldo
 * Date: 5/27/20
 * Time: 10:58 AM
 */
import { tns } from 'tiny-slider/src/tiny-slider';

( function () {
	'use strict';

	const fsic = {
		slider : [],

		init : () => {
			const tnsOptions = {
				container    : '.fsic-carousel-items',
				items        : 1,
				gutter       : 10,
				edgePadding  : 40,
				autoplay     : false,
				mouseDrag    : true,
				nav          : false,
				swipeAngle   : false,
				responsive   : {
					640 : {
						items       : 3,
						edgePadding : 80,
						slideBy     : 3,
					},
					900 : {
						edgePadding : 110,
					}
				},
				controlsText : [
					`<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" id="left-chevron-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
<path d="M172.548,256.005L388.82,39.729c9.089-9.089,9.089-23.824,0-32.912s-23.824-9.089-32.912,0.002
	L123.18,239.551c-4.366,4.363-6.817,10.282-6.817,16.454c0,6.173,2.453,12.093,6.817,16.457l232.727,232.721
	c4.543,4.544,10.499,6.816,16.455,6.816s11.913-2.271,16.457-6.817c9.089-9.089,9.089-23.824,0-32.912L172.548,256.005z"/>
</svg>
`,
					`<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" id="right-chevron-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
<path d="M388.819,239.537L156.092,6.816c-9.087-9.089-23.824-9.089-32.912,0.002
	c-9.087,9.089-9.087,23.824,0.002,32.912l216.27,216.266L123.179,472.272c-9.087,9.089-9.087,23.824,0.002,32.912
	c4.543,4.544,10.499,6.816,16.455,6.816c5.956,0,11.913-2.271,16.457-6.817L388.819,272.45c4.366-4.364,6.817-10.283,6.817-16.455
	C395.636,249.822,393.185,243.902,388.819,239.537z"/>
</svg>
`
				]
			};

			document.querySelectorAll( '.fsic-carousel-items' ).forEach( container => {
				fsic.slider.push( tns( { ...tnsOptions, container } ) );
			} );
		}
	};

	fsic.init();
} )();
